import axios, { HeadersDefaults } from "axios";

interface CommonHeaderProperties extends HeadersDefaults {
  Accept: string;
  "Content-Type": string;
}

const BASE_URL = process.env.NEXT_PUBLIC_BACKEND_URL;

const axiosClient = axios.create();

axiosClient.defaults.baseURL = BASE_URL;

axiosClient.defaults.headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
} as CommonHeaderProperties;

axiosClient.defaults.timeout = 2000;

axiosClient.defaults.withCredentials = true;

export function getRequest(URL: string) {
  return axiosClient.get(`/${URL}`).then((response) => response);
}

export function postRequest(URL: string, payload: any) {
  return axiosClient.post(`/${URL}`, payload).then((response) => response);
}
